import type { Identifier } from "ra-core";
export const sameActor = (
  actor: Identifier | null | undefined,
  current: Identifier | null | undefined,
) => actor != null && current != null && String(actor) === String(current);

export function actorLabel(
  actor: Identifier | null | undefined,
  name: string,
  current?: { id?: Identifier; fullName?: string },
) {
  if (name.trim()) return name;
  if (sameActor(actor, current?.id) && current?.fullName)
    return current.fullName;
  return actor == null ? "Автор не указан" : `Сотрудник #${actor}`;
}
